import React, { useContext, useCallback } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { CheckboxSlider } from 'ui-components/components/checkbox-slider';
import { MDash } from 'ui-components/components/mdash/mdash';

import messages from '../../messages';
import { DeliveryOptionsContext } from '../context';
import DeliveryOptionsItemPropType from '../delivery-option-item-prop-type';
import { fulfillmentPricingModels, pricingModels } from '../enums';
import ServiceDisplay from '../service-display';
import DeliveryOptionActionsButton from './delivery-options-actions-button';
import style from './delivery-options-row.module.less';
import { emptyObject } from 'ui-components/default-props/empty';

const DeliveryOptionsRow = ({ data = emptyObject, isTitle = false }) => {
  const { name, services, pricingModel, isActive, id } = data;
  const { isDeliveryMarketplaceAuctaneFulfillment, setItems, items, onUpdateCallback } = useContext(DeliveryOptionsContext);

  const onIsActiveChangeCallback = useCallback(() => {
    const newItemsList = [...items];
    const index = items.findIndex((i) => i.id === id);
    const itemToUpdate = newItemsList[index];
    itemToUpdate.isActive = !itemToUpdate.isActive;
    setItems(newItemsList);
    onUpdateCallback(itemToUpdate);
  }, [id, items, onUpdateCallback, setItems]);

  const hasServices = services && services.length > 0;

  if (isTitle) {
    return (
      <div className={classnames(style['delivery-options-row'], style.title)}>
        <div className={classnames(style.name, style.header)}>
          <FormattedMessage {...messages.checkoutRateName} />
        </div>
        <div className={classnames(style.pricing, style.header)}>
          <FormattedMessage {...messages.pricing} />
        </div>
        <div className={classnames(style.services, style.header)}>
          <FormattedMessage {...messages.services} />
        </div>
        <div className={classnames(style.actions, style.header)}>
          <FormattedMessage {...messages.actionColumn} />
        </div>
      </div>
    );
  }

  const pricingModelObject = (isDeliveryMarketplaceAuctaneFulfillment ? fulfillmentPricingModels : pricingModels).find(
    (model) => model.id === pricingModel,
  );

  return (
    <div className={classnames(style['delivery-options-row'], style.content)}>
      <div className={style.name}>
        <CheckboxSlider checkboxId={name} checked={isActive} onChange={onIsActiveChangeCallback} />
        {name}
      </div>
      <div className={style.pricing}>{pricingModelObject.displayName}</div>
      <div className={style.services}>
        {hasServices
          ? services.map(({ sellerProviderId, serviceId }) => (
              <ServiceDisplay
                key={`${sellerProviderId}-${serviceId}`}
                className={style.service}
                sellerProviderId={sellerProviderId}
                serviceId={serviceId}
              />
            ))
          : null}
        {!hasServices && <MDash />}
      </div>
      <div className={classnames(style.actions, style['action-button'])}>
        <DeliveryOptionActionsButton data={data} />
      </div>
    </div>
  );
};

DeliveryOptionsRow.propTypes = {
  isTitle: PropTypes.bool,
  data: DeliveryOptionsItemPropType,
};

export default DeliveryOptionsRow;
